import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { computed, watch, onBeforeUnmount } from 'vue';

// Module-level counter so nested modals don't unlock scroll prematurely

export default /*@__PURE__*/_defineComponent({
  __name: 'PopUp',
  props: {
    modelValue: { type: Boolean },
    size: { default: 'md' },
    align: { default: 'center' },
    closeOnOverlay: { type: Boolean, default: true },
    showCloseButton: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    dark: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit: __emit }) {

let _scrollLockCount = 0;

function lockScroll() {
  if (_scrollLockCount === 0) {
    document.body.classList.add('overflow-hidden');
  }
  _scrollLockCount++;
}

function unlockScroll() {
  if (_scrollLockCount > 0) _scrollLockCount--;
  if (_scrollLockCount === 0) {
    document.body.classList.remove('overflow-hidden');
  }
}

const props = __props;

const emit = __emit;

const overlayClass = computed(() =>
  props.dark ? 'bg-black/60' : 'bg-black/30'
);

const alignClass = computed(() =>
  props.align === 'bottom' ? 'items-end sm:items-center' : 'items-center'
);

const maxWidthClass = computed(() =>
  ({ sm: 'max-w-[380px]', md: 'max-w-[520px]', lg: 'max-w-xl' })[props.size]
);

const scrollableClass = computed(() =>
  props.scrollable ? 'max-h-[92vh] overflow-y-auto' : 'overflow-hidden'
);

function handleClose() {
  emit('update:modelValue', false);
  emit('close');
}

function handleOverlayClick() {
  if (props.closeOnOverlay) handleClose();
}

function handleEsc(event: KeyboardEvent) {
  if (event.key === 'Escape') handleClose();
}

watch(
  () => props.modelValue,
  (value) => {
    if (value) {
      lockScroll();
      document.addEventListener('keydown', handleEsc);
    } else {
      unlockScroll();
      document.removeEventListener('keydown', handleEsc);
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  if (props.modelValue) unlockScroll();
  document.removeEventListener('keydown', handleEsc);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "popup-fade" }, {
      default: _withCtx(() => [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["fixed inset-0 z-[9000] flex justify-center backdrop-blur-sm p-4 sm:p-5", [overlayClass.value, alignClass.value]]),
              onClick: _withModifiers(handleOverlayClick, ["self"])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["bg-white rounded-2xl shadow-2xl relative w-full", [maxWidthClass.value, scrollableClass.value]]),
                role: "dialog",
                "aria-modal": "true"
              }, [
                (__props.showCloseButton)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "absolute top-4 right-4 w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-500 z-10 transition",
                      type: "button",
                      onClick: handleClose
                    }, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round"
                      }, [
                        _createElementVNode("line", {
                          x1: "18",
                          y1: "6",
                          x2: "6",
                          y2: "18"
                        }),
                        _createElementVNode("line", {
                          x1: "6",
                          y1: "6",
                          x2: "18",
                          y2: "18"
                        })
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})